export const API_PREFIX = '/api';

export const ENDPOINTS = {
    alertRules: '/alert-rules',
    databaseEvents: '/database-events',
    analyses: '/analyses',
    auth: '/auth',
    cameras: '/cameras',
    events: '/events',
    eventPrompts: '/event-prompts',
    exports: '/exports',
    flir: '/flir',
    hdmi: '/hdmi',
    license: '/license',
    promptAttachments: '/prompt_attachments',
    webhooks: '/webhooks',
    prompts: '/prompts',
    persons: '/persons',
    query: '/query',
    streaming: '/streaming',
    storage: '/storage',
    sources: '/sources',
    sourceFolders: '/source-folders',
    system: '/system',
    vehicles: '/vehicles',
    reports: '/reports',
    procedures: '/procedures',
} as const;
